export default "__VITE_ASSET__B0CuL7ul__"